import React, { useState } from "react";
import DashboardCard from "../../../pages/home/common/DashboardCard";

const JobStats = ({ allJobStats, onClickCard }) => {
  const [activeCard, setActiveCard] = useState("");

  const handleCardClick = (key) => {
    setActiveCard(activeCard === key ? "" : key);
    onClickCard(activeCard === key ? "" : key, allJobStats[key]);
  };

  return (
    <div className="cards-container cards-grid-container grid-4 mt-2rem">
      {Object.keys(allJobStats).map((key, index) => (
        <DashboardCard
          key={index}
          tagName={"campaign"}
          cardLabel={key?.replace(/_/g, " ")}
          value={allJobStats[key] || 0}
          onClickCard={() => handleCardClick(key)}
          isActiveCard={activeCard === key}
        />
      ))}
      {/* <DashboardCard
        tagName={"campaign"}
        cardLabel={"Completed"}
        value={allJobStats?.total_call || 0}
        onClickCard={onClickCard}
      />
      <DashboardCard
        tagName={"campaign"}
        cardLabel={"Running"}
        value={allJobStats?.total_call || 0}
        onClickCard={onClickCard}
      />
      <DashboardCard
        tagName={"campaign"}
        cardLabel={"Remaining"}
        value={allJobStats?.total_call || 0}
        onClickCard={onClickCard}
      /> */}
    </div>
  );
};

export default JobStats;
